import { lazy } from "react";

// The one lazy boundary for the blueprint editor — import BPEditor from here.
//
// 2026-10-23: the editor is konva + react-konva + react-zoom-pan-pinch plus
// ~115 KB of its own tools, around 500 KB of chunk, and it renders for exactly
// one question type (QuestionType.BLUEPRINT) and on two screens that are about
// blueprints. One `import()` call site, so the three callers share one chunk
// instead of carrying a copy each.
const BPEditor = lazy(() => import("./editor"));

export default BPEditor;
